import BaseModel from "./BaseModel";
import {
    action,
    computed,
    makeObservable,
    observable,
} from "mobx";


const toCoordinate = (value) => {
    if (
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return null;
    }


    const number =
        Number(value);


    return Number.isFinite(number)
        ? number
        : null;
};


const isValidPoint = (value) => {
    const lat =
        toCoordinate(value?.lat);

    const lng =
        toCoordinate(value?.lng);


    if (
        lat === null ||
        lng === null
    ) {
        return false;
    }


    return (
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
    );
};


export default class Location_ extends BaseModel {

    constructor(store) {
        super(store);

        makeObservable(this, {
            id: observable,

            name: observable,
            is_main: observable,
            address: observable,
            location: observable,

            was_validated: observable,

            is_valid: computed,

            validate: action,
        });
    }


    id = 0;

    name = "";

    is_main = false;

    address = "";

    location = null;


    was_validated = false;


    get is_valid() {
        return isValidPoint(
            this.location
        );
    }


    validate() {
        this.was_validated = true;

        return this.is_valid;
    }
}